<template>
  <el-form
    ref="form"
    :model="note"
    :rules="rules"
  >
    <el-form-item
      label="Reason For Lost"
      prop="content"
      required
    >
      <el-input
        v-model="note.content"
        type="textarea"
        :rows="5"
        placeholder="Reason For Lost"
        clearable
      />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      note: null,
      rules: {
        content: [
          { required: true, message: 'Reason For Lost is required', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.note = new this.$sdk.note()
  },
  methods: {
    validate () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('validated', this.note)
        }
      })
    }
  }
}
</script>

<style>

</style>
